export function parseBlobIdFromImageUrl(imageUrl: string | null | undefined): string | null {
    if (!imageUrl) return null;
    try {
        const parsed = new URL(imageUrl, 'https://local.invalid');
        const path = parsed.pathname.toLowerCase();
        if (!path.endsWith('/getblob') && !path.endsWith('/api/getblob')) return null;
        const id = parsed.searchParams.get('id')?.trim();
        return id || null;
    } catch {
        return null;
    }
}

export function isDirectHttpImageUrl(imageUrl: string | null | undefined): boolean {
    if (!imageUrl) return false;
    return /^https?:\/\//i.test(imageUrl) && !parseBlobIdFromImageUrl(imageUrl);
}
